module.exports = __webpack_public_path__ + "static/media/instructors.ecc6a6c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instructors.jpg
// module id = 355
// module chunks = 0